<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white">
      <v-tabs  div="tabs" >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}} <v-chip class="white--text" :key="tabRefresh" :color="tab.colour">{{tab.count}}</v-chip> </v-tab>
      </v-tabs>
    </v-toolbar>

    <!-- Active Accounts -->
    <div v-if="displayContents('activeAccounts')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field v-model="activeSearch" label="Search" 
        v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          activeOffset: '0',
          pendingOffset: $route.query.pendingOffset,
          inactiveOffset: $route.query.inactiveOffset,
          pendingRequestOffset: $route.query.pendingRequestOffset,
          resolvedRequestOffset: $route.query.resolvedRequestOffset,
          records: $route.query.records, 
          activeSearch: activeSearch,
          pendingSearch: $route.query.pendingSearch,
          inactiveSearch: $route.query.inactiveSearch,
          pendingRequestSearch: $route.query.pendingRequestSearch,
          resolvedRequestSearch: $route.query.resolvedRequestSearch
          }})"
        ></v-text-field>
      </v-toolbar>
      <v-data-table
        :loading="isLoading"
        :rows-per-page-items="[25, 50, 100, 250, 500, 1000]"
        :items="activeServiceAccounts"
        :headers="activeHeaders"
        disable-initial-sort
        style="cursor: pointer"
        hide-actions
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-layout align-center justify-center>
              <v-icon @click="changeRequest(props.item)">query_builder</v-icon>
            </v-layout>
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.serviceAccountIdentifier}}</td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.id}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.location.locationDescription}}</td>
          <!-- <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
            v-if="props.item.device"
          >{{props.item.device.ponMac}}</td>
          <td v-else></td> -->
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.pppoeUsername}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{formatDate(props.item.fnoActivationDate)}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.packagesIsp.customerOrganisation.name}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
            v-if="props.item.deviceBridge"
          >{{props.item.deviceBridge.vlan}}</td>
          <td v-else @click="routerLinkToDetails(props.item)"></td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
            v-if="props.item.deviceBridge"
          >{{props.item.deviceBridge.vlanXlate}}</td>
          <td v-else @click="routerLinkToDetails(props.item)"></td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.packagesIsp.packagesFno.speedProfile.downloadMbps}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.packagesIsp.packagesFno.speedProfile.uploadMbps}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
            v-if="props.item.deviceBridge"
          >
            <v-icon v-if="props.item.deviceBridge.isActive" color="green">done</v-icon>
            <v-icon v-else color="red">clear</v-icon>
          </td>
          <td v-else></td>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.activeOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="activePage"
              :length="Math.ceil(activeTotalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <!-- Pending Accounts -->
    <div v-if="displayContents('pendingAccounts')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field v-model="pendingSearch" label="Search"
        v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          activeOffset: $route.query.activeOffset,
          pendingOffset: '0',
          inactiveOffset: $route.query.inactiveOffset,
          pendingRequestOffset: $route.query.pendingRequestOffset,
          resolvedRequestOffset: $route.query.resolvedRequestOffset,
          records: $route.query.records, 
          activeSearch: $route.query.activeSearch,
          pendingSearch: pendingSearch,
          inactiveSearch: $route.query.inactiveSearch,
          pendingRequestSearch: $route.query.pendingRequestSearch,
          resolvedRequestSearch: $route.query.resolvedRequestSearch
          }})"
        ></v-text-field>
      </v-toolbar>
      <v-data-table
        :loading="isLoading"
        :rows-per-page-items="[25, 50, 100, 250, 500, 1000]"
        :items="pendingServiceAccounts"
        :headers="headers"
        disable-initial-sort
        hide-actions
        style="cursor: pointer"
      >
        <template v-slot:items="props">
          
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.serviceAccountIdentifier}}</td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.id}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.location.locationDescription}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.authenticationType}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.packagesIsp.customerOrganisation.name}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.innerVlan}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.outerVlan}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.packagesIsp.packagesFno.speedProfile.downloadMbps}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.packagesIsp.packagesFno.speedProfile.uploadMbps}}</td>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.pendingOffset">
        <v-layout wrap>
          <!-- <v-flex xs12 mb-3>
          <span
            style="color: grey"
          >item {{parseInt($route.query.offset) + 1}}-{{parseInt($route.query.offset) + parseInt($route.query.records)}} of {{pagination.totalItems}}</span>
          </v-flex>-->
          <v-flex xs12>
            <v-pagination
              v-model="pendingPage"
              :length="Math.ceil(pendingTotalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <!-- Inactive Accounts -->
    <div v-if="displayContents('inactiveAccounts')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field v-model="inactiveSearch" label="Search"
        v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          activeOffset: $route.query.activeOffset,
          pendingOffset: $route.query.pendingOffset,
          inactiveOffset:'0',
          pendingRequestOffset: $route.query.pendingRequestOffset,
          resolvedRequestOffset: $route.query.resolvedRequestOffset,
          records: $route.query.records, 
          activeSearch: $route.query.activeSearch,
          pendingSearch: $route.query.activeSearch,
          inactiveSearch: inactiveSearch,
          pendingRequestSearch: $route.query.pendingRequestSearch,
          resolvedRequestSearch: $route.query.resolvedRequestSearch
          }})"
        ></v-text-field>
      </v-toolbar>
      <v-data-table
        :loading="isLoading"
        :rows-per-page-items="[25, 50, 100, 250, 500, 1000]"
        :items="inactiveServiceAccounts"
        :headers="inactiveHeaders"
        hide-actions
        disable-initial-sort
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{props.item.serviceAccountIdentifier}}</td>
          <td class="text-xs-center">{{props.item.id}}</td>
          <td class="text-xs-center">{{props.item.location.locationDescription}}</td>
          <td class="text-xs-center">{{formatDate(props.item.fnoDeactivationDate)}}</td>
          <td class="text-xs-center">{{props.item.packagesIsp.customerOrganisation.name}}</td>
          <td
            class="text-xs-center"
            v-if="props.item.deviceBridge"
          >{{props.item.deviceBridge.vlan}}</td>
          <td v-else></td>
          <td
            class="text-xs-center"
            v-if="props.item.deviceBridge"
          >{{props.item.deviceBridge.vlanXlate}}</td>
          <td v-else></td>
          <td
            class="text-xs-center"
          >{{props.item.packagesIsp.packagesFno.speedProfile.downloadMbps}}</td>
          <td class="text-xs-center">{{props.item.packagesIsp.packagesFno.speedProfile.uploadMbps}}</td>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.inactiveOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="inactivePage"
              :length="Math.ceil(inactiveTotalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <!-- Change Requests -->
    <div v-if="displayContents('changeRequests')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field v-if="showPendingRequests" v-model="pendingRequestSearch" label="Search"
        v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          activeOffset: $route.query.activeOffset,
          pendingOffset: $route.query.pendingOffset,
          inactiveOffset: $route.query.inactiveOffset,
          pendingRequestOffset: '0',
          resolvedRequestOffset: $route.query.resolvedRequestOffset,
          records: $route.query.records, 
          activeSearch: $route.query.activeSearch,
          pendingSearch: $route.query.pendingSearch,
          inactiveSearch: $route.query.inactiveSearch,
          pendingRequestSearch: pendingRequestSearch,
          resolvedRequestSearch: $route.query.resolvedRequestSearch
          }})"
        ></v-text-field>
        <v-text-field v-else-if="showResolvedRequests" v-model="resolvedRequestSearch" label="Search"
        v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          activeOffset: $route.query.activeOffset,
          pendingOffset: $route.query.pendingOffset,
          inactiveOffset: $route.query.inactiveOffset,
          pendingRequestOffset: $route.query.pendingRequestOffset,
          resolvedRequestOffset: '0',
          records: $route.query.records, 
          activeSearch: $route.query.activeSearch,
          pendingSearch: $route.query.pendingSearch,
          inactiveSearch: $route.query.inactiveSearch,
          pendingRequestSearch: $route.query.pendingRequestSearch,
          resolvedRequestSearch: resolvedRequestSearch
          }})"
        ></v-text-field>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-tabs>
          <v-tab @click="showPendingRequests=true; showResolvedRequests=false">Pending</v-tab>
          <v-tab @click="showPendingRequests=false; showResolvedRequests=true">Resolved</v-tab>
        </v-tabs>
      </v-toolbar>
      <div v-if="showPendingRequests">
        <v-data-table
          :loading="isLoading"
          :rows-per-page-items="[25, 50, 100, 250, 500, 1000]"
          :items="pendingChangeRequests"
          :headers="changeRequestHeaders"
          hide-actions
          disable-initial-sort
        >
          <template v-slot:items="props">
            <td class="text-xs-center">
              <v-layout row align-center justify-center>
                <v-icon color="light-green" @click="acceptRequestChange(props.item)">done</v-icon>
                <v-icon color="red" @click="denyRequestItem(props.item)">clear</v-icon>
              </v-layout>
            </td>
            <td class="text-xs-center">{{formatDate(props.item.createdAt)}}</td>
            <td class="text-xs-center">{{props.item.serviceAccountId}}</td>
            <td class="text-xs-center" v-if="props.item.status==='Denied'">
              <v-chip class="red white--text">{{props.item.status}}</v-chip>
            </td>
            <td class="text-xs-center" v-if="props.item.status==='Resolved'">
              <v-chip class="primary white--text">{{props.item.status}}</v-chip>
            </td>
            <td class="text-xs-center" v-if="props.item.status==='Pending'">
              <v-chip class="blue white--text">{{props.item.status}}</v-chip>
            </td>
            <td
              class="text-xs-center"
              v-if="props.item.requestType==='Speed Upgrade'||props.item.requestType==='Speed Downgrade'"
            >
              <v-icon v-if="props.item.requestType==='Speed Upgrade'" color="primary">arrow_upward</v-icon>
              <v-icon v-if="props.item.requestType==='Speed Downgrade'" color="red">arrow_downward</v-icon>
              {{props.item.requestType}}
              <br />
              From: {{props.item.fromSpeedProfileName}} Mbps
              <br />
              To: {{props.item.toSpeedProfileName}} Mbps
            </td>
            <td class="text-xs-center" v-else>{{props.item.requestType}}</td>
            <td class="text-xs-center">{{props.item.locationDescription}}</td>
            <td class="text-xs-center">{{formatDate(props.item.requestedChangeDate)}}</td>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2 white" :key="$route.query.pendingRequestOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="pendingRequestPage"
              :length="Math.ceil(pendingRequestTotalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
      </div>
      <div v-if="showResolvedRequests">
        <v-data-table
          :loading="isLoading"
          :rows-per-page-items="[25, 50, 100, 250, 500, 1000]"
          :items="resolvedChangeRequests"
          :headers="resolvedChangeRequestHeaders"
          disable-initial-sort
        >
          <template v-slot:items="props">
            <td class="text-xs-center">{{formatDate(props.item.createdAt)}}</td>
            <td class="text-xs-center">{{props.item.serviceAccountId}}</td>
            <td class="text-xs-center" v-if="props.item.status==='Denied'">
              <v-chip class="red white--text">{{props.item.status}}</v-chip>
            </td>
            <td class="text-xs-center" v-if="props.item.status==='Resolved'">
              <v-chip class="primary white--text">{{props.item.status}}</v-chip>
            </td>

            <td
              class="text-xs-center"
              v-if="props.item.requestType==='Speed Upgrade'||props.item.requestType==='Speed Downgrade'"
            >
              <v-icon v-if="props.item.requestType==='Upgrade'" color="primary">arrow_upward</v-icon>
              <v-icon v-if="props.item.requestType==='Downgrade'" color="red">arrow_downward</v-icon>
              {{props.item.requestType}}
              <br />
              From: {{props.item.fromSpeedProfileName}} Mbps
              <br />
              To: {{props.item.toSpeedProfileName}} Mbps
            </td>
            <td class="text-xs-center" v-else>{{props.item.requestType}}</td>
            <td class="text-xs-center">{{props.item.locationDescription}}</td>
            <td class="text-xs-center">{{formatDate(props.item.requestedChangeDate)}}</td>
            <td class="text-xs-center">{{formatDate(props.item.dateResolved)}}</td>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2 white" :key="$route.query.resolvedRequestOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="resolvedRequestPage"
              :length="Math.ceil(resolvedRequestTotalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
      </div>
    </div>

    <v-dialog v-model="changeRequestDialog" persistent min-width="250px" max-width="500px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Change Request</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="changeRequestDialog=false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-select
            :items="requestTypes"
            label="Request Type"
            v-model="changeRequestItem.requestType"
          ></v-select>
          <v-layout
            wrap
            justify-center
            align-center
            v-if="changeRequestItem.requestType==='Speed Upgrade'||changeRequestItem.requestType==='Speed Downgrade'"
          >
            <v-flex xs12>
              <v-layout align-center justify-center>
                <v-flex xs6>
                  <h3 class="grey--text">From:</h3>
                </v-flex>
                <v-flex xs6>
                  <h3 class="grey--text">To:</h3>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout align-center justify-center>
                <v-flex xs6>
                  <h3 class="grey--text font-weight-light">{{changeRequestItem.fromSpeed.name}}</h3>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete
                    v-if="packagesIsp.length>0&&changeRequestItem.requestType==='Speed Downgrade'&&packagesIsp.filter(x=>x.packagesFno.speedProfile.downloadMbps<changeRequestItem.fromSpeed.downloadMbps).length>0"
                    class="mt-1"
                    :items="packagesIsp.filter(x=>x.packagesFno.speedProfile.downloadMbps<changeRequestItem.fromSpeed.downloadMbps)"
                    v-model="changeRequestItem.toSpeed"
                    item-text="packagesFno.speedProfile.name"
                    return-object
                    label="Select a Speed"
                  ></v-autocomplete>
                  <span
                    class="grey--text"
                    v-else-if="changeRequestItem.requestType==='Speed Downgrade'"
                  >No downgrade speeds available.</span>
                  <v-autocomplete
                    v-if="packagesIsp.length>0&&changeRequestItem.requestType==='Speed Upgrade'&&packagesIsp.filter(x=>x.packagesFno.speedProfile.downloadMbps>changeRequestItem.fromSpeed.downloadMbps).length>0"
                    class="mt-1"
                    :items="packagesIsp.filter(x=>x.packagesFno.speedProfile.downloadMbps>changeRequestItem.fromSpeed.downloadMbps)"
                    v-model="changeRequestItem.toSpeed"
                    item-text="packagesFno.speedProfile.name"
                    return-object
                    label="Select a Speed"
                  ></v-autocomplete>
                  <span
                    v-else-if="changeRequestItem.requestType==='Speed Upgrade'"
                    class="grey--text"
                  >No upgrade speeds available.</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="changeRequestItem.requestType">
            <v-layout justify-center wrap>
              <h3 class="grey--text">Request effective from:</h3>
              <v-date-picker landscape :min="today" v-model="requestedChangeDate" class="mt-3"></v-date-picker>
            </v-layout>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              @click="logServiceAccountChange()"
              color="primary"
              round
              class="white--text"
              v-if="changeRequestItem.requestType==='Termination'"
            >Log Request</v-btn>
            <v-btn
              @click="logServiceAccountChange()"
              color="primary"
              round
              class="white--text"
              v-else-if="(changeRequestItem.requestType=='Speed Upgrade' || changeRequestItem.requestType=='Speed Downgrade')&&changeRequestItem.toSpeed"
            >Log Request</v-btn>
            <v-btn disabled v-else round>Log Request</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Deny Change Request Reason -->
    <v-dialog persistent v-model="denyRequestModal" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h2 class="headline white--text">PLEASE PROVIDE A REASON FOR DENYING THE REQUEST:</h2>
        </v-toolbar>
        <v-layout justify-center>
          <v-textarea class="mx-3" v-model="denyReason" label="Please provide a reason"></v-textarea>
        </v-layout>

        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="denyRequestModal=false,denyReason=''">Cancel</v-btn>
          <v-btn
            v-if="denyReason!==''"
            color="primary"
            round
            @click="denyRequestChange(item),denyRequestModal=false"
          >Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <!-- Reactivation Modal -->
    <v-dialog persistent v-model="reactivateRequestModal" max-width='750px'>
      <v-card>
        <v-toolbar flat class="primary">
          <h2 class="headline white--text">REACTIVATION REQUEST</h2>
        </v-toolbar>
        <v-flex
                xs12
              >
                <v-menu :close-on-content-click="false">
                  <v-text-field
                    :value="requestedChangeDate"
                    slot="activator"
                    label="Reactivation Date"
                    prepend-icon="date_range"
                    required
                  ></v-text-field>
                  <v-date-picker v-model="requestedChangeDate"></v-date-picker>
                </v-menu>
              </v-flex>
        <v-flex xs12 mx-4>
          <v-textarea v-model="reactivateReason" label="Please provide a reason"></v-textarea>
        </v-flex>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="reactivateRequestModal=false,reactivateReason=''">Cancel</v-btn>
          <v-btn
            v-if="reactivateReason!==''"
            color="primary"
            round
            @click="reactivateRequest(editedItem),reactivateRequestModal=false"
          >Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Account Tickets -->
    <v-dialog v-model="viewAccountTicketsModal" persistent max-width="1000px" min-width="500px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Service Account ID: {{selectedAccount.id}} Tickets</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="viewAccountTicketsModal=false">X</v-btn>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-tabs grow>
            <v-tab @click="accountOpenTickets=true">Open</v-tab>
            <v-tab @click="accountOpenTickets=false">Closed</v-tab>
          </v-tabs>
        </v-toolbar>
        <v-card-text v-if="accountOpenTickets" style="overflow-y: auto; max-height:600px">
          <v-layout wrap :key="ticketKey">
            <v-flex
              mx-1
              xs12
              sm12
              md12
              v-if="serviceAccountTickets.filter(x=>!x.isComplete).length==0"
            >
              <v-card flat color="white" height="350px" class="text-xs-center">
                <span class="grey--text">No Open Tickets</span>
                <v-layout align-center></v-layout>
              </v-card>
            </v-flex>
            <v-flex
              v-else
              mx-1
              xs12
              sm6
              md12
              lg4
              v-for="ticket in serviceAccountTickets.filter(x=>!x.isComplete)"
              :key="ticket.id"
            >
              <v-card hover min-width="300px" border-color="red">
                <v-toolbar flat color="primary">
                  <h3
                    class="title white--text"
                  >{{ticket.ticketCategoryItem.ticketCategory.name}}: {{ticket.ticketCategoryItem.name}}</h3>
                </v-toolbar>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-center align-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Status:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text">
                            <v-chip
                              small
                              :class="`${ticket.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`"
                            >{{ticket.currentStatus}}</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center align-center v-if="ticket.isSystemGenerated">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">System Response Status:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text">
                            <v-chip
                              v-if="ticket.systemStatus == 'Success'"
                              small
                              color="green"
                              class="white--text"
                            >{{ticket.systemStatus}}</v-chip>
                            <v-chip
                              v-else-if="ticket.systemStatus == 'Failed'"
                              small
                              color="red"
                              class="white--text"
                            >{{ticket.systemStatus}}</v-chip>
                            <v-chip v-else small color="blue" class="white--text">Pending</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-left>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Ticket ID:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">{{ticket.id}}</h3>
                        </v-flex>
                      </v-layout>
                      <!-- <v-layout justify-center>
                        <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold"> Category: </h2>
                        </v-flex>
                        <v-flex xs6>
                            <h3 class="grey--text font-weight-light">{{ticket.ticketCategoryItem.ticketCategory.name}}</h3>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center>
                        <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold"> Subcategory: </h2>
                        </v-flex>
                        <v-flex xs6>
                            <h3 class="grey--text font-weight-light">{{ticket.ticketCategoryItem.name}}</h3>
                        </v-flex>
                      </v-layout>-->
                      <v-layout justify-center v-if="ticket.description">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Description:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                            style="text-overflow: ellipsis; overflow: hidden;"
                          >{{ticket.description}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Due:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                            v-if="ticket.dueTime === null"
                          >{{formatDate(ticket.dueDate)}}</h3>
                          <h3
                            class="grey--text font-weight-light"
                            v-else
                          >{{formatDate(ticket.dueDate)}} {{ticket.dueTime}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center align-center v-if="!ticket.isSystemGenerated">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Priority:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text">
                            <v-chip
                              small
                              :class="`${ticket.importance.replace(/\s/g,'').toLowerCase()} white--text`"
                            >{{ticket.importance}}</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Created By:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            v-if="ticket.isSystemGenerated"
                            class="grey--text font-weight-light"
                          >System</h3>
                          <h3
                            v-else
                            class="grey--text font-weight-light"
                          >{{ticket.createdBy.name}} {{ticket.createdBy.surname}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Assigned To:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            v-if="ticket.isSystemGenerated"
                            class="grey--text font-weight-light"
                          >System</h3>
                          <h3
                            v-else-if="ticket.assignedTo !==null"
                            class="grey--text font-weight-light"
                          >{{ticket.assignedTo.name}} {{ticket.assignedTo.surname}}</h3>
                          <h3 v-else class="grey--text font-weight-light">Unassigned</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="ticket.resolvedBy !==null">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Resolved By:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                          >{{ticket.resolvedBy.name}} {{ticket.resolvedBy.surname}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-btn
                          color="primary"
                          rounded
                          class="white--text"
                          @click="viewTicket(ticket)"
                        >View</v-btn>
                      </v-layout>
                      <v-layout justify-center>
                        <v-btn
                          color="primary"
                          rounded
                          @click="updateTicket(ticket.id)"
                          v-if="authAdmin($store.state.currentRoute)&&ticket.ticketCategoryItem.name.includes('Create')"
                        >Activate Now</v-btn>
                        <v-btn
                          color="primary"
                          rounded
                          @click="updateTicket(ticket.id)"
                          v-if="authAdmin($store.state.currentRoute)&&ticket.ticketCategoryItem.name.includes('Upgrade')"
                        >Upgrade Service Now</v-btn>
                        <v-btn
                          color="primary"
                          rounded
                          @click="updateTicket(ticket.id)"
                          v-if="authAdmin($store.state.currentRoute)&&ticket.ticketCategoryItem.name.includes('Downgrade')"
                        >Downgrade Service Now</v-btn>
                        <v-btn
                          color="primary"
                          rounded
                          @click="updateTicket(ticket.id)"
                          v-if="authAdmin($store.state.currentRoute)&&ticket.ticketCategoryItem.name.includes('Terminate')"
                        >Terminate Now</v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text v-if="!accountOpenTickets" style="overflow-y: auto; max-height:400px">
          <v-layout wrap :key="ticketKey">
            <v-flex
              mx-1
              xs12
              sm12
              md12
              v-if="serviceAccountTickets.filter(x=>x.isComplete).length==0"
            >
              <v-layout justify-center>
                <v-card flat color="white" height="350px" class="text-xs-center">
                  <span class="grey--text">No Closed Tickets</span>
                </v-card>
              </v-layout>
            </v-flex>
            <v-flex
              v-else
              mx-1
              xs12
              sm4
              md4
              lg4
              v-for="ticket in serviceAccountTickets.filter(x=>x.isComplete)"
              :key="ticket.id"
            >
              <v-card hover min-width="300px" border-color="red" @click="viewTicket(ticket)">
                <v-toolbar flat color="primary">
                  <h3
                    class="title white--text"
                  >{{ticket.ticketCategoryItem.ticketCategory.name}}: {{ticket.ticketCategoryItem.name}}</h3>
                </v-toolbar>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-center align-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Status:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text">
                            <v-chip
                              small
                              :class="`${ticket.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`"
                            >{{ticket.currentStatus}}</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center align-center v-if="ticket.isSystemGenerated">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">System Response Status:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text">
                            <v-chip
                              v-if="ticket.systemStatus == 'Success'"
                              small
                              color="green"
                              class="white--text"
                            >{{ticket.systemStatus}}</v-chip>
                            <v-chip
                              v-else-if="ticket.systemStatus == 'Failed'"
                              small
                              color="red"
                              class="white--text"
                            >{{ticket.systemStatus}}</v-chip>
                            <v-chip v-else small color="blue" class="white--text">Pending</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-left>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Ticket ID:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">{{ticket.id}}</h3>
                        </v-flex>
                      </v-layout>
                      <!-- <v-layout justify-center>
                        <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold"> Category: </h2>
                        </v-flex>
                        <v-flex xs6>
                            <h3 class="grey--text font-weight-light">{{ticket.ticketCategoryItem.ticketCategory.name}}</h3>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center>
                        <v-flex xs6>
                            <h2 class="subheading grey--text font-weight-bold"> Subcategory: </h2>
                        </v-flex>
                        <v-flex xs6>
                            <h3 class="grey--text font-weight-light">{{ticket.ticketCategoryItem.name}}</h3>
                        </v-flex>
                      </v-layout>-->
                      <v-layout justify-center v-if="ticket.description">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Description:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                            style="text-overflow: ellipsis; overflow: hidden;"
                          >{{ticket.description}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Due:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                            v-if="ticket.dueTime === null"
                          >{{formatDate(ticket.dueDate)}}</h3>
                          <h3
                            class="grey--text font-weight-light"
                            v-else
                          >{{formatDate(ticket.dueDate)}} {{ticket.dueTime}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center align-center v-if="!ticket.isSystemGenerated">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Priority:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text">
                            <v-chip
                              small
                              :class="`${ticket.importance.replace(/\s/g,'').toLowerCase()} white--text`"
                            >{{ticket.importance}}</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Created By:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            v-if="ticket.isSystemGenerated"
                            class="grey--text font-weight-light"
                          >System</h3>
                          <h3
                            v-else
                            class="grey--text font-weight-light"
                          >{{ticket.createdBy.name}} {{ticket.createdBy.surname}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Assigned To:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            v-if="ticket.isSystemGenerated"
                            class="grey--text font-weight-light"
                          >System</h3>
                          <h3
                            v-else-if="ticket.assignedTo !==null"
                            class="grey--text font-weight-light"
                          >{{ticket.assignedTo.name}} {{ticket.assignedTo.surname}}</h3>
                          <h3 v-else class="grey--text font-weight-light">Unassigned</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="ticket.resolvedBy !==null">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Resolved By:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                          >{{ticket.resolvedBy.name}} {{ticket.resolvedBy.surname}}</h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Ticket View Modal -->
    <v-dialog v-model="viewTicketModal" persistent max-width="1000px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">VIEW TICKET: {{ticketItem.dueDate}}</h3>
          <v-spacer></v-spacer>

          <!-- <v-btn v-if="ticketItem.ticketCategoryId&&ticketItem.ticketCategoryItemId&&ticketItem.currentStatus&&ticketItem.importance" flat color="white" class="white--text" @click="editTicketSave()">Save</v-btn>
          <v-btn v-else disabled flat>Save</v-btn>-->
          <v-btn
            flat
            color="white"
            class="white--text"
            @click="viewTicketModal=false, ticketItem={}"
          >X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center align-center>
            <v-flex xs2>
              <v-checkbox
                v-if="!ticketItem.isSystemGenerated"
                label="Full Day Event"
                v-model="dateTimeSelect"
              ></v-checkbox>
              <v-checkbox v-else disabled label="Full Day Event" v-model="dateTimeSelect"></v-checkbox>
            </v-flex>
            <v-flex xs5>
              <VueCtkDateTimePicker
                v-if="!ticketItem.isSystemGenerated"
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />
              <VueCtkDateTimePicker
                v-else
                disabled
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />
            </v-flex>
            <v-flex xs5>
              <VueCtkDateTimePicker
                v-if="!ticketItem.isSystemGenerated&&!dateTimeSelect"
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketItem.dueTime"
              />
              <VueCtkDateTimePicker
                v-else
                disabled
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketItem.dueTime"
              />
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-flex xs3>
              <v-autocomplete
                v-if="!ticketItem.isSystemGenerated"
                xs6
                :items="ticketCategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryId"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                disabled
                xs6
                :items="ticketCategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                disabled
                v-if="!ticketItem.isSystemGenerated&&ticketItem.ticketCategoryId"
                xs6
                :items="ticketCategoryItems.filter(x=>x.ticketCategoryId === ticketItem.ticketCategoryId &&x.isActive && !x.isDeleted)"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryItemId"
              ></v-autocomplete>
              <v-autocomplete
                v-else-if="ticketItem.isSystemGenerated"
                disabled
                xs6
                :items="ticketCategoryItems.filter(x=>x.ticketCategoryId === ticketItem.ticketCategoryId &&x.isActive && !x.isDeleted)"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryItemId"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                xs6
                disabled
                :items="ticketCategories"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-if="!ticketItem.isSystemGenerated"
                :items="statuses"
                label="Status"
                v-model="ticketItem.currentStatus"
              ></v-select>
              <v-select
                v-else
                disabled
                :items="statuses"
                label="Status"
                v-model="ticketItem.currentStatus"
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
                disabled
                :items="importanceOptions"
                label="Importance"
                v-model="ticketItem.importance"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <!-- <v-flex xs4 v-if="!ticketItem.isSystemGenerated">
                            <v-autocomplete
                            v-model="ticketItem.assignedToId"
                            :items="filteredUsers"
                            :filter="filterObject"
                            chips
                            clearable
                            item-text="name"
                            item-value="id"
                            label="Assign Ticket to a User"
                            >
                            <template v-slot:selection="{ attr, on, item, selected }">
                                <v-chip
                                v-bind="attr"
                                :input-value="selected"
                                color="blue-grey"
                                class="white--text"
                                v-on="on"
                                >
                                <v-icon left>person</v-icon>
                                <span>{{item.name}} {{item.surname}}</span>
                                </v-chip>
                            </template>
                            <template v-slot:item="{ item }">
                                <v-avatar
                                size="35px"
                                color="primary"
                                class="title font-weight-light white--text"
                                v-if="item!=='undefined'"
                                >
                                {{ item.name.charAt(0) }}{{ item.surname.charAt(0) }}
                                </v-avatar>
                                <v-list-item-content >
                                <v-list-item-title  class="grey--text ml-3">{{item.name}} {{item.surname}}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                            </v-autocomplete>
            </v-flex>-->
            <v-flex mt-3 v-if="ticketItem.isSystemGenerated">
              <span class="grey--text">System Process</span>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-if="!ticketItem.isSystemGenerated"
                :items="locationTypeList"
                label="Type of Associated Location"
                v-model="locationType"
              ></v-select>
              <v-select
                v-else
                disabled
                :items="locationTypeList"
                label="Type of Associated Location"
                v-model="locationType"
              ></v-select>
            </v-flex>
            <v-flex xs3 v-if="locationType==='Switching Centre'">
              <v-autocomplete
                :items="switchingcentres"
                label="Select a Switching Centre"
                item-value="id"
                item-text="name"
                v-model="ticketItem.switchingCentreId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 v-if="locationType==='Location Node'">
              <v-autocomplete
                :items="locationnodes"
                label="Select a Node"
                item-value="id"
                item-text="name"
                v-model="ticketItem.locationNodeId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 v-if="locationType==='Location Network'">
              <v-autocomplete
                :items="locationnetworks"
                label="Select a Network"
                item-value="id"
                item-text="name"
                v-model="ticketItem.locationNetworkId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs2 v-if="locationType==='End Location'">
              <v-btn
                v-if="!ticketItem.isSystemGenerated&&!ticketItem.locationId"
                round
                color="primary"
                class="white--text"
                @click="addLocationModal=true"
              >Add Location</v-btn>
              <v-btn
                v-else-if="!ticketItem.isSystemGenerated"
                round
                color="primary"
                class="white--text"
                @click="addLocationModal=true"
              >Edit Location</v-btn>
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-textarea
              label="Description"
              v-if="!ticketItem.isSystemGenerated"
              outline
              auto-grow
              v-model="ticketItem.description"
            ></v-textarea>
            <v-textarea
              label="Description"
              v-else
              disabled
              outline
              auto-grow
              v-model="ticketItem.description"
            ></v-textarea>
          </v-layout>
          <v-layout justify-center align-center v-if="ticketAssignedLog.length>0" mb-2>
            <v-flex xs2>
              <h3 class="grey--text">Assignment Log:</h3>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-for="assigned in ticketAssignedLog" :key="assigned.id">
            <v-layout justify-left align-center class="text-xs-left">
              <v-flex xs3>
                <span class="grey--text">{{formatDateTime(assigned.createdAt)}}</span>
              </v-flex>
              <v-flex xs9>
                <span class="grey--text font-weight-light">
                  <b>{{assigned.assignedBy.name}} {{assigned.assignedBy.surname}}</b>
                  assigned the ticket to
                  <b>{{assigned.assignedTo.name}} {{assigned.assignedTo.surname}}</b>
                </span>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-layout justify-center align-center mt-4 mb-2>
            <v-flex xs2>
              <h3 class="grey--text">Comments:</h3>
            </v-flex>
            <v-flex xs1>
              <v-icon color="primary" @click="addCommentBox=true">add_circle_outline</v-icon>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="ticketCommentLog.length===0&&!addCommentBox">
            <h3 class="grey--text font-weight-light">No Comments</h3>
          </v-flex>
          <v-flex xs12 v-if="addCommentBox">
            <v-textarea label="Comment" outline auto-grow v-model="comment"></v-textarea>
            <v-btn
              round
              color="primary"
              class="white--text"
              @click="addCommentEditedTicket(comment)"
            >Comment</v-btn>
          </v-flex>
          <v-flex xs12 v-for="comment in ticketCommentLog" :key="comment.createdAt">
            <v-layout justify-left align-center class="text-xs-left">
              <v-flex xs2>
                <span class="grey--text font-weight-light">{{formatDateTime(comment.createdAt)}}</span>
              </v-flex>
              <v-flex xs2>
                <span
                  class="grey--text font-weight-bold"
                >{{comment.commentedBy.name}} {{comment.commentedBy.surname}}</span>
              </v-flex>

              <v-flex xs8>
                <span class="grey--text font-weight-light">{{comment.comment}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Reactivation Request -->
    <v-dialog persistent v-model="reactivateRequestModal" max-width='750px'>
      <v-card>
        <v-toolbar flat class="primary">
          <h2 class="headline white--text">REACTIVATION REQUEST</h2>
        </v-toolbar>
        <v-flex
                xs12
              >
                <v-menu :close-on-content-click="false">
                  <v-text-field
                    :value="item.requestedChangeDate"
                    slot="activator"
                    label="Reactivation Date"
                    prepend-icon="date_range"
                    read-only
                    required
                  ></v-text-field>
                  <v-date-picker :min="today" v-model="item.requestedChangeDate"></v-date-picker>
                </v-menu>
              </v-flex>
        <v-flex xs12 mx-4>
          <v-textarea v-model="reactivateReason" label="Please provide a reason"></v-textarea>
        </v-flex>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="reactivateRequestModal=false,reactivateReason=''">Cancel</v-btn>
          <v-btn
            v-if="reactivateReason!==''"
            color="primary"
            round
            @click="reactivateRequest(item),reactivateRequestModal=false"
          >Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";

export default {
  data() {
    return {
      requestTypes: ["Speed Upgrade", "Speed Downgrade", "Termination"],
      isLoading: true,
      activeTabName: "",
      tabRefresh: 0,
      //   Pages
      activePage: 1,
      pendingPage: 1,
      inactivePage: 1,
      pendingRequestPage: 1,
      resolvedRequestPage: 1,
      //   Searches
      activeSearch: "",
      pendingSearch: "",
      inactiveSearch: "",
      pendingRequestSearch: "",
      resolvedRequestSearch: "",
      //   Pagination
      activePagination: {
        rowsPerPage: 25
      },
      pendingPagination: {},
      inactivePagination: {
        rowsPerPage: 25
      },
      pendingRequestPagination: {},
      resolvedRequestPagination: {},
    //   Totals
      activeTotalItems: 0,
      pendingTotalItems: 0,
      inactiveTotalItems: 0,
      pendingRequestTotalItems: 0,
      resolvedRequestTotalItems: 0,

      changeRequestDialog: false,
      changeRequestTab: false,
      accountOpenTickets: true,
      requestedChangeDate: new Date().toISOString().substr(0, 10),
      today: new Date().toISOString().substr(0, 10),

      activeAccounts: true,
      pendingAccounts: false,
      inactiveAccounts: false,
      viewTicketModal: false,
      showResolvedRequests: false,
      showPendingRequests: true,

      denyRequestModal: false,
      denyReason: "",
      item: {},
      changeRequestItem: {
        requestType: "",
        fromSpeed: null,
        toSpeed: null,
        terminate: false
      },
      defaultChangeRequestItem: {
        requestType: "",
        fromSpeed: null,
        toSpeed: null,
        terminate: false
      },
      allServiceAccounts: [],
      activeServiceAccounts: [],
      pendingChangeRequests: [],
      resolvedChangeRequests: [],
      pendingServiceAccounts: [],
      inactiveServiceAccounts: [],
      allLocations: [],
      allNetworks: [],
      allCustomers: [],
      allSpeedProfiles: [],
      allIspPackages: [],
      packagesIsp: [],
      reactivateRequestModal: false,
      serviceAccountTickets: [],
      viewAccountTicketsModal: false,
      selectedAccount: {},
      ticketCommentLog: [],
      ticketAssignedLog: [],
      ticketItem: {},
      snackbar: false,
      text: "",
      y: "top",
      locationTypeList: [
        "End Location",
        "Location Network",
        "Location Node",
        "Switching Centre"
      ],
      locationType: "End Location",
      tributeOptions: { lookup: "name", values: this.users },
      addCommentBox: false,
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      ticketCategoryItems: [],
      ticketCategories: [],
      comment: "",
      ticketKey: 0,
      dateTimeSelect: false,
      setIntervalId: null,
      tabs: [
        { name: "activeAccounts", displayName: "Active", count: 0, colour: 'light-green' },
        { name: "pendingAccounts", displayName: "Pending", count: 0, colour: 'blue' },
        { name: "inactiveAccounts", displayName: "Inactive", count: 0, colour: 'red' },
        { name: "changeRequests", displayName: "Change Requests", count: 0, colour: 'warning' }
      ],
      activeHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
         {
          text: "Account Code",
          align: "center",
          value: "serviceAccountIdentifier"
        },
        {
          text: "Identifier",
          align: "center",
          value: "id"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        // {
        //   text: "Device",
        //   align: "center",
        //   value: "device.ponMac"
        // },
        {
          text: "PPPOE Username",
          align: "center",
          value: "pppoeUsername"
        },
        {
          text: "Date Activated",
          align: "center",
          value: "fnoActivationDate"
        },
        {
          text: "ISP",
          align: "center",
          value: "packagesIsp.customerOrganisation.name"
        },
        {
          text: "Inner VLAN",
          align: "center",
          value: "deviceBridge.innerVlan"
        },
        {
          text: "Outer VLAN",
          align: "center",
          value: "deviceBridge.outerVlan"
        },
        {
          text: "Download Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "Upload Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.uploadMbps"
        },
        {
          text: "Connection Active",
          align: "center",
          value: "deviceBridge.isActive"
        }
      ],
      headers: [
        {
          text: "Account Code",
          align: "center",
          value: "serviceAccountIdentifier"
        },
        {
          text: "Identifier",
          align: "center",
          value: "id"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Authentication",
          align: "center",
          value: "authenticationType"
        },
        {
          text: "ISP",
          align: "center",
          value: "packagesIsp.customerOrganisation.name"
        },
        {
          text: "Inner VLAN",
          align: "center",
          value: "deviceBridge.innerVlan"
        },
        {
          text: "Outer VLAN",
          align: "center",
          value: "deviceBridge.outerVlan"
        },
        {
          text: "Download Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "Upload Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.uploadMbps"
        }
      ],
      inactiveHeaders: [
        {
          text: "Account Code",
          align: "center",
          value: "serviceAccountIdentifier"
        },
        {
          text: "Identifier",
          align: "center",
          value: "id"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Deactivation Date",
          align: "center",
          value: "fnoDeactivationDate"
        },
        {
          text: "ISP",
          align: "center",
          value: "packagesIsp.customerOrganisation.name"
        },
        {
          text: "Inner VLAN",
          align: "center",
          value: "deviceBridge.innerVlan"
        },
        {
          text: "Outer VLAN",
          align: "center",
          value: "deviceBridge.outerVlan"
        },
        {
          text: "Download Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "Upload Mbps",
          align: "center",
          value: "packagesIsp.packagesFno.speedProfile.uploadMbps"
        }
      ],
      changeRequestHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Created",
          align: "center",
          value: "vlan.serviceVlan"
        },
        {
          text: "Service Account Identitifer",
          align: "center",
          value: "serviceAccountId"
        },
        {
          text: "Status",
          align: "center",
          value: "status"
        },

        {
          text: "Request Type",
          align: "center",
          value: "requestType"
        },
        {
          text: "Location",
          align: "center",
          value: "locationDescription"
        },
        {
          text: "Requested Change Date",
          align: "center",
          value: "requestedChangeDate"
        }
      ],
      resolvedChangeRequestHeaders: [
        {
          text: "Created",
          align: "center",
          value: "createdAt"
        },
        {
          text: "Service Account Identifier",
          align: "center",
          value: "serviceAccountId"
        },
        {
          text: "Status",
          align: "center",
          value: "status"
        },
        {
          text: "Request Type",
          align: "center",
          value: "Request Type"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Requested Change Date",
          align: "center",
          value: "requestedChangeDate"
        },
        {
          text: "Resolved Date",
          align: "center",
          value: "dateResolved"
        }
      ]
    };
  },
  watch: {
    activeTabName(){
      this.activePage = 1
      this.inactivePage = 1
      this.pendingPage = 1
      this.pendingRequestPage = 1
      this.resolvedRequestPage = 1
    },
       '$route.query.activeSearch':{
      immediate: true,
      handler(value){
        this.isLoading=true
      if(this.$route.query.activeSearch&&value!==""&&value != null){
        this.activePage = 1

        Api()
        .get('/serviceAccounts/AllActive/twoDevice',{
          params: {
          search: this.$route.query.activeSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.activeServiceAccounts=response.data.result
          this.activeTotalItems=response.data.count
            this.isLoading=false
          })} else if(this.$route.query.activeOffset){
             Api()
        .get('/serviceAccounts/AllActive/twoDevice',{
          params: {
          offset: this.$route.query.activeOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.activeServiceAccounts=response.data.result
          this.activeTotalItems=response.data.count
            this.isLoading=false})
          }
      }
    },
    '$route.query.activeOffset': {
       immediate: true,
      handler(value){
        this.isLoading=true
      if(value!==""&&value != null&&this.$route.query.activeSearch&&this.$route.query.activeSearch!="" &&this.$route.query.activeSearch!== null){      
        
        Api()
        .get('/serviceAccounts/AllActive/twoDevice',{
          params: {
          search: this.$route.query.activeSearch,
          offset: this.$route.query.activeOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.activeServiceAccounts=response.data.result
          this.activeTotalItems=response.data.count
            this.isLoading=false})
      } else if(value != null){
         Api()
        .get('/serviceAccounts/AllActive/twoDevice',{
          params: {
          offset: this.$route.query.activeOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.activeServiceAccounts=response.data.result
          this.activeTotalItems=response.data.count
            this.isLoading=false})
      }
    }},
     activePage(value) {
      this.activePagination.page = this.activePage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.activeSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              activeOffset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              inactiveOffset: this.$route.query.inactiveOffset,
              pendingRequestOffset: this.$route.query.pendingRequestOffset,
              resolvedRequestOffset: this.$route.query.resolvedRequestOffset,
              activeSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch,
              inactiveSearch: this.$route.query.inactiveSearch,
              pendingRequestSearch: this.$route.query.pendingRequestSearch,
              resolvedRequestSearch: this.$route.query.resolvedRequestSearch
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              activeOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              inactiveOffset: this.$route.query.inactiveOffset,
              pendingRequestOffset: this.$route.query.pendingRequestOffset,
              resolvedRequestOffset: this.$route.query.resolvedRequestOffset,
              records: this.$route.query.records,
              pendingSearch: this.$route.query.pendingSearch,
              inactiveSearch: this.$route.query.inactiveSearch,
              pendingRequestSearch: this.$route.query.pendingRequestSearch,
              resolvedRequestSearch: this.$route.query.resolvedRequestSearch
            }
          });
        }
      }
    },

    // Pending Accounts
    '$route.query.pendingSearch':{
      immediate: true,
      handler(value){
        this.isLoading=true
      if(this.$route.query.pendingSearch&&value!==""&&value != null){
        this.pendingPage = 1
        Api()
        .get('/serviceAccounts/pending/twoDevice',{
          params: {
          search: this.$route.query.pendingSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingServiceAccounts=response.data.result
          this.pendingTotalItems=response.data.count
            this.isLoading=false
          })} else if(this.$route.query.pendingOffset){
             Api()
        .get('/serviceAccounts/pending/twoDevice',{
          params: {
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingServiceAccounts=response.data.result
          this.pendingTotalItems=response.data.count
            this.isLoading=false})
          }
      }
    },
    '$route.query.pendingOffset': {
       immediate: true,
      handler(value){
        this.isLoading=true
      if(value!==""&&value != null&&this.$route.query.pendingSearch&&this.$route.query.pendingSearch!="" &&this.$route.query.pendingSearch!== null){      
        
        Api()
        .get('/serviceAccounts/pending/twoDevice',{
          params: {
          search: this.$route.query.pendingSearch,
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingServiceAccounts=response.data.result
          this.pendingTotalItems=response.data.count
            this.isLoading=false})
      } else if(value != null){
         Api()
        .get('/serviceAccounts/pending/twoDevice',{
          params: {
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingServiceAccounts=response.data.result
          this.pendingTotalItems=response.data.count
            this.isLoading=false})
      }
    }},
     pendingPage(value) {
      this.pendingPagination.page = this.pendingPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.pendingSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              activeOffset: this.$route.query.activeOffset,
              records: this.$route.query.records,
              pendingOffset: (value - 1) * this.$route.query.records,
              inactiveOffset: this.$route.query.inactiveOffset,
              pendingRequestOffset: this.$route.query.pendingRequestOffset,
              resolvedRequestOffset: this.$route.query.resolvedRequestOffset,
              activeSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch,
              inactiveSearch: this.$route.query.inactiveSearch,
              pendingRequestSearch: this.$route.query.pendingRequestSearch,
              resolvedRequestSearch: this.$route.query.resolvedRequestSearch
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              activeOffset: this.$route.query.activeOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              inactiveOffset: this.$route.query.inactiveOffset,
              pendingRequestOffset: this.$route.query.pendingRequestOffset,
              resolvedRequestOffset: this.$route.query.resolvedRequestOffset,
              records: this.$route.query.records,
              activeSearch: this.$route.query.activeSearch,
              inactiveSearch: this.$route.query.inactiveSearch,
              pendingRequestSearch: this.$route.query.pendingRequestSearch,
              resolvedRequestSearch: this.$route.query.resolvedRequestSearch
            }
          });
        }
      }
    },

    // Inactive Accounts
    '$route.query.inactiveSearch':{
      immediate: true,
      handler(value){
        this.isLoading=true
      if(this.$route.query.inactiveSearch&&value!==""&&value != null){
        this.inactivePage = 1

        Api()
        .get('/serviceAccounts/inactive/twoDevice',{
          params: {
          search: this.$route.query.inactiveSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.inactiveServiceAccounts=response.data.result
          this.inactiveTotalItems=response.data.count
            this.isLoading=false
          })} else if(this.$route.query.inactiveOffset){
             Api()
        .get('/serviceAccounts/inactive/twoDevice',{
          params: {
          offset: this.$route.query.inactiveOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.inactiveServiceAccounts=response.data.result
          this.inactiveTotalItems=response.data.count
            this.isLoading=false})
          }
      }
    },
    '$route.query.inactiveOffset': {
       immediate: true,
      handler(value){
        this.isLoading=true
      if(value!==""&&value != null&&this.$route.query.inactiveSearch&&this.$route.query.inactiveSearch!="" &&this.$route.query.inactiveSearch!== null){      
        
        Api()
        .get('/serviceAccounts/inactive/twoDevice',{
          params: {
          search: this.$route.query.inactiveSearch,
          offset: this.$route.query.inactiveOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.inactiveServiceAccounts=response.data.result
          this.inactiveTotalItems=response.data.count
            this.isLoading=false})
      } else if(value != null){
         Api()
        .get('/serviceAccounts/inactive/twoDevice',{
          params: {
          offset: this.$route.query.inactiveOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.inactiveServiceAccounts=response.data.result
          this.inactiveTotalItems=response.data.count
            this.isLoading=false})
      }
    }},
     inactivePage(value) {
      this.inactivePagination.page = this.inactivePage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.inactiveSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              activeOffset: this.$route.query.activeOffset,
              records: this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              inactiveOffset: (value - 1) * this.$route.query.records,
              pendingRequestOffset: this.$route.query.pendingRequestOffset,
              resolvedRequestOffset: this.$route.query.resolvedRequestOffset,
              activeSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch,
              inactiveSearch: this.$route.query.inactiveSearch,
              pendingRequestSearch: this.$route.query.pendingRequestSearch,
              resolvedRequestSearch: this.$route.query.resolvedRequestSearch
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              activeOffset: this.$route.query.activeOffset,
              pendingOffset: this.$route.query.pendingOffset,
              inactiveOffset: (value - 1) * this.$route.query.records,
              pendingRequestOffset: this.$route.query.pendingRequestOffset,
              resolvedRequestOffset: this.$route.query.resolvedRequestOffset,
              records: this.$route.query.records,
              activeSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch,
              pendingRequestSearch: this.$route.query.pendingRequestSearch,
              resolvedRequestSearch: this.$route.query.resolvedRequestSearch
            }
          });
        }
      }
    },

    // Pending Requests
    '$route.query.pendingRequestSearch':{
      immediate: true,
      handler(value){
        this.isLoading=true
      if(this.$route.query.pendingRequestSearch&&value!==""&&value != null){
        this.pendingRequestPage = 1

        Api()
        .get('/serviceAccountsAuditLog/pending',{
          params: {
          search: this.$route.query.pendingRequestSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingChangeRequests=response.data.result
          this.pendingRequestTotalItems=response.data.count
            this.isLoading=false
          })} else if(this.$route.query.pendingRequestOffset){
             Api()
        .get('/serviceAccountsAuditLog/pending',{
          params: {
          offset: this.$route.query.pendingRequestOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingChangeRequests=response.data.result
          this.pendingRequestTotalItems=response.data.count
            this.isLoading=false})
          }
      }
    },
    '$route.query.pendingRequestOffset': {
       immediate: true,
      handler(value){
        this.isLoading=true
      if(value!==""&&value != null&&this.$route.query.pendingRequestSearch&&this.$route.query.pendingRequestSearch!="" &&this.$route.query.pendingRequestSearch!== null){      
        
        Api()
        .get('/serviceAccountsAuditLog/pending',{
          params: {
          search: this.$route.query.pendingRequestSearch,
          offset: this.$route.query.pendingRequestOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingChangeRequests=response.data.result
          this.pendingRequestTotalItems=response.data.count
            this.isLoading=false})
      } else if(value != null){
         Api()
        .get('/serviceAccountsAuditLog/pending',{
          params: {
          offset: this.$route.query.pendingRequestOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.pendingChangeRequests=response.data.result
          this.pendingRequestTotalItems=response.data.count
            this.isLoading=false})
      }
    }},
     pendingRequestPage(value) {
      this.pendingRequestPagination.page = this.pendingRequestPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.pendingRequestSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              activeOffset: this.$route.query.activeOffset,
              records: this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              inactiveOffset: this.$route.query.inactiveOffset,
              pendingRequestOffset: (value - 1) * this.$route.query.records,
              resolvedRequestOffset: this.$route.query.resolvedRequestOffset,
              activeSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch,
              inactiveSearch: this.$route.query.inactiveSearch,
              pendingRequestSearch: this.$route.query.pendingRequestSearch,
              resolvedRequestSearch: this.$route.query.resolvedRequestSearch
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              activeOffset: this.$route.query.activeOffset,
              pendingOffset: this.$route.query.pendingOffset,
              inactiveOffset: this.$route.query.inactiveOffset,
              pendingRequestOffset: (value - 1) * this.$route.query.records,
              resolvedRequestOffset: this.$route.query.resolvedRequestOffset,
              records: this.$route.query.records,
              activeSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch,
              inactiveSearch: this.$route.query.inactiveSearch,
              resolvedRequestSearch: this.$route.query.resolvedRequestSearch
            }
          });
        }
      }
    },

    // Resolved Requests
    '$route.query.resolvedRequestSearch':{
      immediate: true,
      handler(value){
        this.isLoading=true
      if(this.$route.query.resolvedRequestSearch&&value!==""&&value != null){
        this.resolvedRequestPage = 1

        Api()
        .get('/serviceAccountsAuditLog/resolved',{
          params: {
          search: this.$route.query.resolvedRequestSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedChangeRequests=response.data.result
          this.resolvedRequestTotalItems=response.data.count
            this.isLoading=false
          })} else if(this.$route.query.resolvedRequestOffset){
             Api()
        .get('/serviceAccountsAuditLog/resolved',{
          params: {
          offset: this.$route.query.resolvedRequestOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedChangeRequests=response.data.result
          this.resolvedRequestTotalItems=response.data.count
            this.isLoading=false})
          }
      }
    },
    '$route.query.resolvedRequestOffset': {
       immediate: true,
      handler(value){
        this.isLoading=true
      if(value!==""&&value != null&&this.$route.query.resolvedRequestSearch&&this.$route.query.resolvedRequestSearch!="" &&this.$route.query.resolvedRequestSearch!== null){      
        
        Api()
        .get('/serviceAccountsAuditLog/resolved',{
          params: {
          search: this.$route.query.resolvedRequestSearch,
          offset: this.$route.query.resolvedRequestOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedChangeRequests=response.data.result
          this.resolvedRequestTotalItems=response.data.count
            this.isLoading=false})
      } else if(value != null){
         Api()
        .get('/serviceAccountsAuditLog/resolved',{
          params: {
          offset: this.$route.query.resolvedRequestOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedChangeRequests=response.data.result
          this.resolvedRequestTotalItems=response.data.count
            this.isLoading=false})
      }
    }},
     resolvedRequestPage(value) {
      this.resolvedRequestPagination.page = this.resolvedRequestPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.resolvedRequestSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              activeOffset: this.$route.query.activeOffset,
              records: this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              inactiveOffset: this.$route.query.inactiveOffset,
              pendingRequestOffset: this.$route.query.pendingRequestOffset,
              resolvedRequestOffset: (value - 1) * this.$route.query.records,
              activeSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch,
              inactiveSearch: this.$route.query.inactiveSearch,
              pendingRequestSearch: this.$route.query.pendingRequestSearch,
              resolvedRequestSearch: this.$route.query.resolvedRequestSearch
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              activeOffset: this.$route.query.activeOffset,
              pendingOffset: this.$route.query.pendingOffset,
              inactiveOffset: this.$route.query.inactiveOffset,
              pendingRequestOffset: this.$route.query.pendingRequestOffset,
              resolvedRequestOffset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              activeSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch,
              inactiveSearch: this.$route.query.inactiveSearch,
              pendingRequestSearch: this.$route.query.pendingRequestSearch
            }
          });
        }
      }
    }
    },
  created() {
      this.activeTabName = "activeAccounts"
    this.initialize();
    this.$router.push({
      name: this.$route.name,
      query: {
        activeOffset: "0",
        pendingOffset: "0",
        inactiveOffset: "0",
        pendingRequestOffset: "0",
        resolvedRequestOffset: "0",
        records: "15"
      }
    });
      this.initialize();

    // this.setIntervalId = setInterval(() => {
    //   /// call your function here
    //   this.initialize();
    // }, 30000);
  },
  async beforeDestroy() {
    await this.clearIntervalListener(this.setIntervalId);
  },
  methods: {
      displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    clearIntervalListener(id) {
      clearInterval(id);
    },
    initialize() {
      this.activePagination.totalItems = this.totalitems;
      this.activePage = 1;
      this.getTotals()
      // this.getAllServiceAccounts();
      this.fetchCustomers();
      this.fetchSpeedProfiles();
      this.getAllIspPackages();
      // this.getChangeRequests();
      this.fetchTicketCategories();
      this.fetchTicketCategoryItems();
    },
    async getTotals(){
      // Active Accounts
        this.activeTotalItems = await this.activeServiceAccountTotal()
        this.tabs[0].count = this.activeTotalItems
        this.activePagination.totalItems = this.activeTotalItems

        // Pending Accounts
        this.pendingTotalItems = await this.pendingServiceAccountTotal()
        this.tabs[1].count = this.pendingTotalItems
        this.pendingPagination.totalItems = this.pendingTotalItems

        // Inactive Accounts
        this.inactiveTotalItems = await this.inactiveServiceAccountTotal()
        this.tabs[2].count = this.inactiveTotalItems
        this.inactivePagination.totalItems = this.inactiveTotalItems

        // Pending Change Requests
        this.pendingRequestTotalItems = await this.pendingRequestTotal()
        this.tabs[3].count = this.pendingRequestTotalItems
        this.pendingRequestPagination.totalItems = this.pendingRequestTotalItems

        // Resolved Change Requests
        this.resolvedRequestTotalItems = await this.resolvedRequestTotal()
        this.resolvedRequestPagination.totalItems = this.resolvedRequestTotalItems

        this.tabRefresh += 1
    },
    reactivateRequestItem(item){
      this.item = Object.assign({}, item);
      this.reactivateRequestModal = true;
    },
    fetchTicketCategories() {
      Api()
        .get("/ticketCategory")
        .then(response => {
          this.ticketCategories = response.data;
        });
    },
    async activeServiceAccountTotal(){
        let result = null
        await Api().get('/serviceAccounts/allActive/twoDevice/count')
        .then(response=>{
            result = response.data.count
        })
        return result
    },
    async pendingServiceAccountTotal(){
        let result = null
        await Api().get('/serviceAccounts/pending/twoDevice/count')
        .then(response=>{
            result = response.data.count
        })
        return result
    },
    async inactiveServiceAccountTotal(){
        let result = null
        await Api().get('/serviceAccounts/inactive/twoDevice/count')
        .then(response=>{
            result = response.data.count
        })
        return result
    },
    async pendingRequestTotal(){
        let result = null
        await Api().get('/serviceAccountsAuditLog/pending/count')
        .then(response=>{
            result = response.data.count
        })
        return result
    },
    async resolvedRequestTotal(){
        let result = null
        await Api().get('/serviceAccountsAuditLog/resolved/count')
        .then(response=>{
            result = response.data.count
        })
        return result
    },
    fetchTicketCategoryItems() {
      Api()
        .get("/ticketCategoryItem")
        .then(response => {
          this.ticketCategoryItems = response.data;
          this.ticketKey += 1;
        });
    },
    getChangeRequests() {
      Api()
        .get("/serviceAccountsAuditLog")
        .then(response => {
          this.changeRequests = response.data;
        });
    },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    async routerLinkToDetails(item) {
      let route = await this.$store.state.currentOrg.org.permissions.filter(
        function(el) {
          return el.url === "/serviceAccounts/:serviceAccountId";
        }
      );
      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({ path: "/serviceAccounts/" + item.id });
    },
    async updateTicket(id) {
      await Api()
        .put("/ticket/" + id, {
          dueDate: new Date()
          // dueTime: new Date()
        })
        .then(async response => {
          this.viewAccountTicketsModal = false;
          this.snackbar = true;
          this.text = "Successfully triggered immediate provisioning!";
          //   await Api().get('/ticket/byServiceAccount/'+this.selectedAccount.id)
          // .then(response=>{
          //   this.serviceAccountTickets=response.data
          // })
        });
    },
    async viewAccountTickets(item) {
      this.selectedAccount = item;
      this.serviceAccountTickets = [];
      await Api()
        .get("/ticket/byServiceAccount/" + item.id)
        .then(response => {
          this.serviceAccountTickets = response.data;
        });
      this.viewAccountTicketsModal = true;
    },

    async fetchCustomers() {
      await Api()
        .get("/organisation/subOrganisations/ISP")
        .then(response => {
          this.allCustomers = response.data;
        });
    },
    viewTicket(item) {
      this.ticketItem = item;
      if (this.ticketItem.dueTime === null) {
        this.dateTimeSelect = false;
      } else {
        this.dateTimeSelect = true;
      }
      if (this.ticketItem.id) {
        this.fetchTicketComments(this.ticketItem.id);
      }
      this.fetchTicketAssignments(this.ticketItem.id);
      this.ticketItem.ticketCategoryId = this.ticketItem.ticketCategoryItem.ticketCategoryId;
      this.viewTicketModal = true;
    },
    fetchTicketComments(id) {
      Api()
        .get("/ticketComment/byTicket/" + id)
        .then(response => {
          this.ticketCommentLog = response.data;
        });
    },
    fetchTicketAssignments(id) {
      Api()
        .get("/ticketAssignLog/byTicket/" + id)
        .then(response => {
          this.ticketAssignedLog = response.data;
        });
    },
    addCommentEditedTicket(comment) {
      Api()
        .post("/ticketComment", {
          ticketId: this.ticketItem.id,
          type: "comment",
          commentedById: this.$store.state.user.id,
          comment: comment
        })
        .then(response => {
          response.data.commentedBy = this.$store.state.user;
          this.ticketCommentLog.push(response.data);
          this.comment = "";
          this.addCommentBox = false;
        });
    },

    acceptRequestChange(item) {
      let newServiceAccountId = null;
      if (this.authAdmin(this.$store.state.currentRoute)) {
        if (item.requestType !== "Termination") {
          let locationId = null;
          let deviceId = null;
          if (item.requestType === "Migration") {
            locationId = item.migrationLocationId;
            deviceId = null;
          } else {
            locationId = item.locationId;
            deviceId = item.deviceId;
          }
          Api().put("/serviceAccounts/" + item.serviceAccountId, {
            ispDeactivationDate: item.requestedChangeDate,
            fnoDeactivationDate: item.requestedChangeDate
          });
          if (item.authenticationType === "PPPoE") {
            item.IPoEActive = null;
          } else {
            item.IPoEActive = true;
          }
          let packagesIspId = null;
          if (item.toPackageId === null) {
            packagesIspId = item.packagesIspId;
          } else {
            packagesIspId = item.toPackageId;
          }
          Api()
            .post("/serviceAccounts", {
              serviceAccountIdentifier: item.serviceAccountIdentifier.toString(),
              authenticationType: item.authenticationType,
              pppoeUsername: item.pppoeUsername || null,
              pppoePassword: item.pppoePassword || null,
              IPoEMacAddress: item.IPoEMacAddress,
              initialActivation: item.initialActivation,
              fnoActivationDate: item.requestedChangeDate || null,
              fnoDeactivationDate: null,
              ispActivationDate: item.requestedChangeDate || null,
              ispDeactivationDate: null,
              staticIpv4: item.staticIpv4 || null,
              staticIpv6: item.staticIpv6 || null,
              isChange: true,
              locationId: locationId,
              customerOrganisationId: item.customerOrganisationId,
              deviceId: deviceId,
              packagesIspId: packagesIspId,
              vlanId: item.vlanId,
              IPoEActive: item.IPoEActive,
              contactId: item.primaryContactId,
              isDeleted: false,
              isActive: true
            })
            .then(response => {
              newServiceAccountId = response.data.id;
            });
        } else {
          Api().put("/serviceaccounts/" + item.serviceAccountId, {
            fnoDeactivationDate: item.requestedChangeDate,
            ispDeactivationDate: item.requestedChangeDate
          });
        }
        let autoProvision = false;
        let autoProvisionType = null;
        if (
          item.device &&
          item.device != null &&
          item.device.Handle_ID != null
        ) {
          autoProvision = true;
          autoProvisionType = "Zhone";
        } else if (
          item.device &&
          item.device != null &&
          item.device.acsDevice
        ) {
          autoProvision = true;
          autoProvisionType = "ACS";
        }
        let bridge = null;
        if (item.serviceAccount.deviceBridge) {
          bridge = item.serviceAccount.deviceBridge.connectionId;
        }

        let uploadMbps = 0;
        let downloadMbps = 0;
        if (item.toSpeedProfile && item.toSpeedProfile != null) {
          uploadMbps = item.toSpeedProfile.uploadMbps;
          downloadMbps = item.toSpeedProfile.downloadMbps;
        }
        // let obj = {
        //    fnoContactName:
        //       this.$store.state.user.name + " " + this.$store.state.user.surname,
        //       requestedChangeDate: item.requestedChangeDate,
        //       deviceId: item.deviceId,
        //       requestType: item.requestType,
        //       serviceAccountId: newServiceAccountId || item.serviceAccountId,
        //       connectionId: bridge,
        //       deviceBridgeId: item.serviceAccount.deviceBridgeId,
        //       uploadMbps: uploadMbps,
        //       downloadMbps: downloadMbps,
        //     isActive: false,
        //     status: "Resolved",
        //     dateResolved: new Date()
        // }
        // console.log(obj)
        // debugger
        Api()
          .put("/serviceAccountsAuditLog/" + item.id, {
            autoProvision: autoProvision,
            autoProvisionType: autoProvisionType,
            ponMac: item.device.ponMac,
            customerOrganisationId: item.customerOrganisationId,
            fnoContactName:
              this.$store.state.user.name +
              " " +
              this.$store.state.user.surname,
            requestedChangeDate: item.requestedChangeDate,
            deviceId: item.deviceId,
            requestType: item.requestType,
            serviceAccountId: newServiceAccountId || item.serviceAccountId,
            connectionId: bridge,
            deviceBridgeId: item.serviceAccount.deviceBridgeId,
            uploadMbps: uploadMbps,
            downloadMbps: downloadMbps,
            isActive: false,
            status: "Resolved",
            dateResolved: new Date()
          })
          .then(response => {
            (this.requestedChangeDate = new Date().toISOString().substr(0, 10)),
              this.initialize();
          });
      } else {
        confirm(
          "You do not have the required permissions to process this request. Please contact your system administrator for further assistance."
        );
      }
    },
    async getAllIspPackages() {
      Api()
        .get("/supplier/packagesIsps/basic/active")
        .then(response => {
          this.allIspPackages = response.data;
        });
    },
    logServiceAccountChange() {
      if (this.authAdmin(this.$store.state.currentRoute)) {
        if (this.changeRequestItem.fnoActivationDate !== null) {
          this.changeRequestItem.fnoActivationDate = new Date(
            this.changeRequestItem.fnoActivationDate
          )
            .toISOString()
            .substr(0, 10);
        }
        if (this.changeRequestItem.ispActivationDate !== null) {
          this.changeRequestItem.ispActivationDate = new Date(
            this.changeRequestItem.ispActivationDate
          )
            .toISOString()
            .substr(0, 10);
        }
        if (this.changeRequestItem.fnoDeactivationDate !== null) {
          this.changeRequestItem.fnoDeactivationDate = new Date(
            this.changeRequestItem.fnoDeactivationDate
          )
            .toISOString()
            .substr(0, 10);
        }
        if (this.changeRequestItem.ispDeactivationDate !== null) {
          this.changeRequestItem.ispDeactivationDate = new Date(
            this.changeRequestItem.ispDeactivationDate
          )
            .toISOString()
            .substr(0, 10);
        }
        if (this.changeRequestItem.initialActivation !== null) {
          this.changeRequestItem.initialActivation = new Date(
            this.changeRequestItem.initialActivation
          )
            .toISOString()
            .substr(0, 10);
        }
        if (this.changeRequestItem.requestType !== "Termination") {
          this.changeRequestItem.isChange = true;
        }
        Api().put("/serviceAccounts/" + this.changeRequestItem.id, {
          isChange: false
        });
        let toSpeedId = null;
        let toSpeedName = null;
        let toPackageId = null;
        if (this.changeRequestItem.toSpeed) {
          toSpeedId = this.changeRequestItem.toSpeed.packagesFno.speedProfileId;
          toSpeedName =
            this.changeRequestItem.toSpeed.packagesFno.speedProfile
              .downloadMbps +
            "/" +
            this.changeRequestItem.toSpeed.packagesFno.speedProfile.uploadMbps;
          toPackageId = this.changeRequestItem.toSpeed.id;
        }
        Api()
          .post("/serviceAccountsAuditLog", {
            status: "Pending",
            serviceAccountId: this.changeRequestItem.id,
            serviceAccountIdentifier: this.changeRequestItem
              .serviceAccountIdentifier,
            locationId: this.changeRequestItem.locationId,
            // vlanId: this.changeRequestItem.vlan.id,
            packagesIspId: this.changeRequestItem.packagesIspId,
            locationDescription: this.changeRequestItem.location
              .locationDescription,
            customerOrganisationId: this.changeRequestItem.packagesIsp
              .customerOrganisationId,
            ispName: this.changeRequestItem.packagesIsp.customerOrganisation
              .name,
            requestType: this.changeRequestItem.requestType,
            isChange: this.changeRequestItem.isChange,
            ispNotification: true,
            fnoNotification: true,
            ispContactName: null,
            fnoContactName:
              this.$store.state.user.name +
              " " +
              this.$store.state.user.surname,
            fromSpeedProfileName:
              this.changeRequestItem.packagesIsp.packagesFno.speedProfile
                .downloadMbps +
              "/" +
              this.changeRequestItem.packagesIsp.packagesFno.speedProfile
                .uploadMbps,
            fromSpeedProfileId: this.changeRequestItem.packagesIsp.packagesFno
              .speedProfileId,
            toSpeedProfileId: toSpeedId,
            toSpeedProfileName: toSpeedName,
            toPackageId: toPackageId,
            initialActivation: this.changeRequestItem.initialActivation || null,
            fnoActivationDate: this.changeRequestItem.fnoActivationDate || null,
            fnoDeactivationDate:
              this.changeRequestItem.fnoDeactivationDate || null,
            ispActivationDate: this.changeRequestItem.ispActivationDate || null,
            ispDeactivationDate:
              this.changeRequestItem.ispDeactivationDate || null,
            requestedChangeDate: this.requestedChangeDate,
            staticIpv4: this.changeRequestItem.staticIpv4 || null,
            staticIpv6: this.changeRequestItem.staticIpv6 || null,
            deviceId: this.changeRequestItem.deviceId,
            isDeleted: this.changeRequestItem.isDeleted,
            isActive: this.changeRequestItem.isActive
          })
          .then(async response => {
            this.changeRequestItem.serviceAccountAuditLogId = response.data.id;
            await this.acceptFNOChange(this.changeRequestItem);
            this.initialize(), (this.changeRequestDialog = false);
            this.changeRequestItem = {};
          });
      } else {
        confirm(
          "You do not have the required permissions to process this request. Please contact your system administrator for further assistance."
        );
      }
    },
    denyRequestChange(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        Api()
          .put("/serviceAccountsAuditLog/" + item.id, {
            fnoContactName:
              this.$store.state.user.name +
              " " +
              this.$store.state.user.surname,
            comment: this.denyReason,
            isActive: false,
            status: "Denied"
          })
          .then(this.initialize());
      }
    },
    denyRequestItem(item) {
      this.item = {};
      if (this.authAdmin(this.$store.state.currentRoute)) {
        this.item = Object.assign({}, item);
        this.denyRequestModal = true;
      } else {
        confirm(
          "You do not have the required permissions to process this request. Please contact your system administrator for further assistance."
        );
      }
    },
    async acceptFNOChange(item) {
      let newServiceAccountId = null;
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (item.requestType !== "Termination") {
          let locationId = null;
          let deviceId = null;
          if (item.requestType !== "Migration") {
            locationId = item.location.id;
            deviceId = item.deviceId;
          } else {
            locationId = this.migrationLocationId;
            deviceId = null;
          }

          Api().put("/serviceAccounts/" + item.id, {
            ispDeactivationDate: this.requestedChangeDate,
            fnoDeactivationDate: this.requestedChangeDate
          });
          if (item.authenticationType === "PPPoE") {
            item.IPoEActive = null;
          } else {
            item.IPoEActive = true;
          }

          await Api()
            .post("/serviceAccounts", {
              serviceAccountIdentifier: item.serviceAccountIdentifier.toString(),
              authenticationType: item.authenticationType,
              pppoeUsername: item.pppoeUsername || null,
              pppoePassword: item.pppoePassword || null,
              IPoEMacAddress: item.IPoEMacAddress,
              initialActivation: item.initialActivation,
              fnoActivationDate: this.requestedChangeDate || null,
              fnoDeactivationDate: null,
              ispActivationDate: this.requestedChangeDate || null,
              ispDeactivationDate: null,
              staticIpv4: item.staticIpv4 || null,
              staticIpv6: item.staticIpv6 || null,
              isChange: true,
              locationId: locationId,
              deviceId: deviceId,
              packagesIspId: item.toSpeed.id || item.packagesIspId,
              // vlanId: item.vlan.id,
              customerOrganisationId: item.customerOrganisationId,
              deviceBridgeId: item.deviceBridgeId,
              innerVlan: item.innerVlan,
              outerVlan: item.outerVlan,
              IPoEActive: false,
              isDeleted: false,
              isActive: true
            })
            .then(response => {
              newServiceAccountId = response.data.id;
            });
        } else {
          Api().put("/serviceaccounts/" + item.id, {
            fnoDeactivationDate: this.requestedChangeDate,
            ispDeactivationDate: this.requestedChangeDate
          });
        }
        let uploadMbps = 0;
        let downloadMbps = 0;
        if (item.toSpeed && item.toSpeed != null) {
          uploadMbps = item.toSpeed.packagesFno.speedProfile.uploadMbps;
          downloadMbps = item.toSpeed.packagesFno.speedProfile.downloadMbps;
        }
        let autoProvision = false;
        let autoProvisionType = null;
        if (
          item.device &&
          item.device != null &&
          item.device.Handle_ID != null
        ) {
          autoProvision = true;
          autoProvisionType = "Zhone";
        } else if (
          item.device &&
          item.device != null &&
          item.device.acsDevice
        ) {
          autoProvision = true;
          autoProvisionType = "ACS";
        }
        // debugger
        Api()
          .put("/serviceAccountsAuditLog/" + item.serviceAccountAuditLogId, {
            autoProvision: autoProvision,
            autoProvisionType: autoProvisionType,
            ponMac: item.device.ponMac,
            customerOrganisationId: item.customerOrganisationId,
            fnoContactName:
              this.$store.state.user.name +
              " " +
              this.$store.state.user.surname,
            requestedChangeDate: this.requestedChangeDate,
            deviceId: item.deviceId,
            requestType: item.requestType,
            serviceAccountId: newServiceAccountId || item.id,
            connectionId: item.deviceBridge.connectionId,
            deviceBridgeId: item.deviceBridgeId,
            uploadMbps: uploadMbps,
            downloadMbps: downloadMbps,
            isActive: false,
            status: "Resolved",
            dateResolved: new Date()
          })
          .then(response => {
            // debugger
            (this.requestedChangeDate = new Date().toISOString().substr(0, 10)),
              this.initialize();
          });
      }
    },

    fetchSpeedProfiles() {
      Api()
        .get("/speedProfiles")
        .then(response => {
          this.allSpeedProfiles = response.data;
        });
    },

    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    async changeRequest(item) {
      if (this.authAdmin(this.$store.state.currentRoute)) {
        this.changeRequestItem = item;
        this.changeRequestItem.fromSpeed =
          item.packagesIsp.packagesFno.speedProfile;
        this.packagesIsp = await this.allIspPackages.filter(
          x =>
            x.isActive &&
            !x.isDeleted &&
            new Date() >= new Date(x.startDate) &&
            (x.endDate == null || new Date() <= new Date(x.endDate)) &&
            x.customerOrganisationId === item.customerOrganisationId &&
            x.locationNetworkId === item.location.locationNetworkId
        );
        this.changeRequestDialog = true;
      } else {
        confirm(
          "You do not have the required permissions to process this request. Please contact your system administrator for further assistance."
        );
      }
    }
  }
};
</script>